import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";
import PuxPageDetails from "../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";
import SmartTable from "../../../global/components/table/table.vue";
import TeamsModalCreate from "../TeamsModalCreate/TeamsModalCreate.vue";

import getTableApi from "../../../const/TableApis";

const TABLE_ID = "team";

// @vue/component
export default {
  name: "TeamsList",
  components: {
    PageTabTitle,
    PuxPageDetails,
    PuxTranslate,
    SmartTable,
    TeamsModalCreate,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: "_LBL_TEAMS_LIST_ROW_ACTION_DETAILS_",
            route: "root.teams.details",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            label: "_TXT_TEAMS_TABLE_ACTION_CREATE_",
            callback: () => this.modal.create = true,
            type: "button",
            className: "btn btn-primary",
            icon: "glyphicon-plus",
            htmlId: "team_create",
          },
        ],
        label: "_LBL_TEAMS_LIST_",
        sortable: true,
        pagination: true,
        details: false,
        view: {
          filter: "top",
        },
      },
      modal: {
        create: undefined,
      },
      currentBerichte: undefined,
      currentIndex: undefined,
    };
  },
  methods: {
    closeModalCreate() {
      this.modal.create = false;
    },
  },
};
